<template>
  <li class="select-dropdown__item" v-if="mode === 'normal'">
    <el-checkbox :value="itemSelected" @click.native.prevent.stop="selectOptionClick">{{ label }}</el-checkbox>
  </li>
  <li class="select-dropdown__item" v-else>
    <el-checkbox class="extra-checkbox" :value="itemSelected" @click.native.prevent.stop="selectOptionClick">
      {{ label }}
    </el-checkbox>
    <el-input
      class="extra-input"
      :value="extraValue"
      @input="changeValue"
      :placeholder="extraInputPlaceholder"
      :maxlength="extraInputMaxLength"
    ></el-input>
  </li>
</template>

<script>
import Emitter from 'element-ui/src/mixins/emitter';

export default {
  mixins: [Emitter],
  name: 'historyOption',
  inject: ['select'],
  props: {
    label: [String, Number],
    value: { required: true },
    mode: {
      type: String,
      default: 'normal'
    },
    extraInputPlaceholder: { type: String, default: '请输入过往病史，最多20个字' },
    extraInputMaxLength: {
      type: Number,
      default: 20
    }
  },
  data() {
    return {
      extraValue: ''
    };
  },
  computed: {
    itemSelected() {
      return this.contains(this.select.value, this.value);
    }
  },
  watch: {
    'select.value': {
      handler(val, oldVal) {
        if (
          val &&
          val.some(item => {
            return item.indexOf('其他') > -1;
          }) &&
          val !== oldVal
        ) {
          this.extraValue = val.find(o => o.indexOf('其他') > -1).replace('其他', '');
        }
      },
      immediate: true
    }
  },
  methods: {
    contains(arr = [], target) {
      return (
        arr &&
        arr.some(item => {
          return item === target || item.startsWith(target);
        })
      );
    },
    selectOptionClick() {
      this.dispatch('HistorySelect', 'handleOptionClick', [this, true]);
    },
    changeValue(val) {
      this.extraValue = val;
      if (this.itemSelected) {
        this.dispatch('HistorySelect', 'handleOptionClick', [this, false]);
      }
    }
  },
  created() {
    this.select.options.push(this);
    this.select.optionsCount++;
  }
};
</script>

<style lang="scss">
.select-dropdown__item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 10px;
  height: 40px;

  &:hover {
    background-color: #f5f7fa;
  }

  .extra-checkbox {
    margin-right: 5px;
  }

  .extra-input {
    flex: 1;
  }
}
</style>
